module.exports = __webpack_public_path__ + "static/img/indibamb.e87d73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indibamb.png
// module id = omLI
// module chunks = 3